var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0781 4.01043C10.3589 4.24473 6.74277 8.51869 6.74277 13.4649V17.9373L5.19542 21.2186C5.1927 21.2246 5.19004 21.2306 5.18744 21.2367C4.56494 22.6321 5.57262 24.3076 7.03581 24.3076H11.9971C11.9971 26.3359 13.5758 28 15.5 28C17.4242 28 19.0029 26.3359 19.0029 24.3076H23.9631C25.4263 24.3076 26.4353 22.6324 25.8126 21.2367C25.81 21.2306 25.8074 21.2246 25.8046 21.2186L24.2573 17.9373V13.2305C24.2573 7.99586 20.0908 3.76168 15.0781 4.01043ZM15.1602 5.85421C19.2003 5.65372 22.5058 9.02259 22.5058 13.2305V18.1537C22.5057 18.2963 22.5369 18.437 22.5971 18.5648L24.2277 22.0239C24.3325 22.2608 24.2112 22.4614 23.9631 22.4614H7.03581C6.78774 22.4614 6.6674 22.2612 6.77241 22.0239V22.0227L8.403 18.5648C8.46312 18.437 8.49434 18.2963 8.49422 18.1537V13.4649C8.49422 9.46452 11.4013 6.04083 15.1602 5.85421ZM13.7486 24.3076H17.2515C17.2515 25.3379 16.4774 26.1538 15.5 26.1538C14.5226 26.1538 13.7486 25.3379 13.7486 24.3076Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/iconNotification.58e0e014dda2aedd2e6917db7b524598.svg";
export { ForwardRef as ReactComponent };